import Vue from 'vue';

// ATTENTION seuls les composants basiques peuvent utiliser ce hub
const AppEvent = new Vue();
export default AppEvent;
